export default __webpack_public_path__ + "static/media/NH01.478c91c7.jpg";